import axios from 'axios';
import getUrl from 'utils/getUrl';
import { generateApiError } from './utils/apiErrorMessages';

const deleteImage = imageId =>
  axios.delete(getUrl.apiV2(`images/${imageId}`)).catch(generateApiError());

export default deleteImage;
